var $4b42de5fe4f4a48e$exports = {};
$4b42de5fe4f4a48e$exports = {
    "valid": `\u{414}\u{456}\u{439}\u{441}\u{43D}\u{438}\u{439}`
};


export {$4b42de5fe4f4a48e$exports as default};
//# sourceMappingURL=uk-UA.module.js.map
